(() => {
  const key='giftieness-hide-very-rude';
  const toggles=Array.from(document.querySelectorAll('[data-gx-rude-toggle]'));
  const excluded='[data-gx-very-rude="true"]';
  function isHidden(){return document.documentElement.classList.contains('gx-hide-very-rude')}
  function apply(hidden,persist){
    document.documentElement.classList.toggle('gx-hide-very-rude',!!hidden);
    toggles.forEach(input=>input.checked=!!hidden);
    document.querySelectorAll('[data-gx-hide-summary]').forEach(label=>{
      const scope=label.closest('.gx-collection-main, .gx-search-results')||document;
      const count=scope.querySelectorAll(excluded).length;
      label.hidden=!hidden;
      if(hidden)label.textContent=count>0?count+' very rude '+(count===1?'design':'designs')+' hidden on this page':'Very rude designs are hidden across the site';
    });
    if(persist){try{localStorage.setItem(key,hidden?'1':'0')}catch(e){}}
  }
  apply(isHidden(),false);
  document.addEventListener('change',event=>{
    const input=event.target.closest('[data-gx-rude-toggle]');
    if(input)apply(!!input.checked,true);
  });
  document.addEventListener('click',event=>{
    const reset=event.target.closest('[data-gx-clear-filters]');
    if(reset)apply(false,true);
  });
  window.addEventListener('storage',event=>{
    if(event.key===key)apply(event.newValue==='1',false);
  });
})();